import { render, staticRenderFns } from "./pageElementFiles.vue?vue&type=template&id=92b64c54&scoped=true&"
import script from "./pageElementFiles.vue?vue&type=script&lang=js&"
export * from "./pageElementFiles.vue?vue&type=script&lang=js&"
import style0 from "./pageElementFiles.vue?vue&type=style&index=0&id=92b64c54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b64c54",
  null
  
)

export default component.exports